import * as Yup from 'yup'



export const validationSchemas = (isHito,isAudiencia) => {
   
  let validationObject = { };
  if(isHito){

    validationObject["fechaHitoJudicial"] = Yup.date().required('La Fecha es obligatoria.');
   }
   validationObject["minutaHitoContacto"] = Yup.string().test(
     "len",
     "No puede exeder 1000 caracteres..",
     (val) => {
       if (val === undefined) {
         return true;
       }
       return val.length === 0 || (val.length >= 0 && val.length <= 1000);
     }
   );
   if(isAudiencia){
 
    validationObject["fechaAudiencia"] = Yup.date().required('La Fecha es obligatoria.');
   }
   validationObject["minutaHitoJudicial"] = Yup.string().test(
     "len",
     "No puede exeder 1000 caracteres..",
     (val) => {
       if (val === undefined) {
         return true;
       }
       return val.length === 0 || (val.length >= 0 && val.length <= 1000);
     }
     );
     validationObject["competencia"] = Yup.string().required('Este campo es obligatorio.');
     validationObject["corte"] = Yup.string().required('Este campo obligatorio.');
     validationObject["tribunal"] = Yup.string().required('Este campo es obligatorio.');
     validationObject["rol"] = Yup.string().required('La Este campo obligatorio.');
     validationObject["fechaIngresoCausa"] = Yup.date().required('Este campo obligatorio.');
    

  return Yup.object().shape(validationObject);
}

